export default function getFormatedDate(date: string): string {
  const date_parts = date.split('-');
  return `${date_parts[2]}/${date_parts[1]}/${date_parts[0]}`;
}
